<template src="./template.html"></template>
<script>
import urlUtils from 'utils/urlUtils'

export default {
  name: 'event-card-1',
  props: {
    event: {
      type: Object,
      required: true,
    },
    direction: {
      type: String,
      default: 'horizontal',
    },
    verticalMode: {
      type: Boolean,
      default: false,
    },
    //THEMEING
    theme: {
      type: String,
      default: 'theme-light',
    },
    buttonText: {
      type: String,
      default: 'Get Tickets',
    },
    buttonBgColor: {
      type: String,
    },
    buttonTextColor: {
      type: String,
    },
  },
  computed: {
    useSquareImages() {
      return this.event && this.event.venue && this.event.venue.id === '60acb7281388e6a8' //xalos
    },
    buttonBgColorSanitized() {
      if (!this.buttonBgColor) return null

      if (!this.buttonBgColor.startsWith('#')) return `#${this.buttonBgColor}`

      return this.buttonBgColor
    },
    buttonTextColorSanitized() {
      if (!this.buttonTextColor) return null

      if (!this.buttonTextColor.startsWith('#')) return `#${this.buttonTextColor}`

      return this.buttonTextColor
    },
  },
  data() {
    return {}
  },
  methods: {
    onEventClick() {
      this.$emit('eventClick', this.event)
    },
    imgLoaded() {
      this.$emit('updated')
    },
    getImageUrl(src) {
      if (!src) return ''

      return urlUtils.optimizedImageUrl(src)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/EventCard1/index.vue